import $$ from "cmn-utils";
import alarm from "./alarm";

export default {
  alarm,
};
